import React, { useState } from 'react'
import { FbAlertErrorIcon, BlueTickIcon, CancelIcon, FbTagsInfoIcon } from '../../icon';
import { ChanneTicketingStatus, ChannelAccountModel, ChannelAccountStatus, ChannelType, Fb24HourWindowTags } from '../../models/channels/channels.model';
import { ChannelConversationStatus } from '../../models/conversations';
import { Autocomplete, Dialog, DialogContent, DialogTitle, TextField, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { AppRoutes } from '../routes/route.path';
import * as selector from '../../selectors/selectors';
import { useSelector } from 'react-redux';

interface IProps {
    ChannelType: number;
    ChannelAccountID: string;
    ChannelStatus: number;
    SelectedFbTag: string;
    HandleWindowTags: (x: any) => void;
    Channels: ChannelAccountModel[];
    TicketingStatus: ChanneTicketingStatus;
}

const ChannelErrorMessageComponent = (props: IProps) => {
    const [messageTagsInfoOpen, setMessageTagsInfoOpen] = useState<boolean>(false)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const onChange = (e, value) => {
        props.HandleWindowTags(value)
    }

    const handleMessageTagsInfo = () => {
        setMessageTagsInfoOpen(!messageTagsInfoOpen)
    }

    return (
        <div>
            <div className={`d-flex justify-between  align-center brt-4 h6-regular ${IsMobileDevice ? "bb-primary-divider-1" :"border-msg fbtagsmessageborder"} pl-1 min-h-5 max-h-7`}>
                <div className="d-flex">
                    <div className="my-auto">
                        {(props.Channels?.find(x => x.ID === props.ChannelAccountID)?.Status === ChannelAccountStatus.DISCONNECTED || props.Channels?.find(x => x.ID === props.ChannelAccountID)?.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY) ?
                            <div className=" my-auto h-5 d-flex">

                                <div className=' d-flex justify-center align-center w-5 '> <FbAlertErrorIcon className={"mx-1"} /></div>
                                <div className='d-flex justify-center align-center'>
                                    <div className=' color-primary-danger o-y-scroll'> You have disconnected your
                                        <span className="color-primary-link "><Link to={AppRoutes.CHANNELS}> {props?.Channels?.find(x => x.ID === props?.ChannelAccountID)?.NickName} </Link> </span>Page. Please connect again to start messaging.
                                    </div>
                                </div>
                            </div>
                            :
                            (props.ChannelStatus === ChannelConversationStatus.INACTIVE || props.TicketingStatus === ChanneTicketingStatus.Closed) ?
                                <div className={` my-auto ${props.ChannelType === ChannelType.FACEBOOK ? "h-7" : "h-5"} d-flex`}>

                                    <div className=' d-flex justify-center align-center w-5 '> <FbAlertErrorIcon className={"mx-1"} /></div>
                                    {props.ChannelType === ChannelType.FACEBOOK ?
                                        <div className='d-flex justify-center align-center'>
                                            <div className=' color-primary-danger o-y-scroll'> You can’t text the user as It has been more than 24 hrs since customer last texted you.
                                                Please use
                                                <span className="color-primary-link"> MESSAGE TAGS </span>
                                                to reply.
                                            </div>
                                        </div>
                                        :
                                        <div className='d-flex justify-center align-center'>
                                            <div className=' color-primary-danger o-y-scroll'>
                                                This user is no longer availble to Chat.
                                            </div>
                                        </div>
                                    }
                                </div>
                                :
                                props.ChannelStatus === ChannelConversationStatus.CONVERSATION_WINDOW_EXPIRED &&
                                <div className=" my-auto h-5 d-flex">
                                    <div className=' d-flex justify-center align-center w-5 '> <FbAlertErrorIcon className={"mx-1"} /></div>
                                    <div className='d-flex justify-center align-center'>
                                        <div className=' color-primary-danger o-y-scroll'> This contact hasn't interacted with you for more than 7 days. So can't reply to this conversation
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
                {props.ChannelStatus === ChannelConversationStatus.INACTIVE && props.Channels?.find(x => x.ID === props.ChannelAccountID)?.Status !== ChannelAccountStatus.DISCONNECTED && props.ChannelType === ChannelType.FACEBOOK &&
                    <div className="w-p-35 d-flex mr-1">
                        <Autocomplete
                            className={"p-1 w-p-100"}
                            size="small"
                            value={props.SelectedFbTag}
                            onChange={onChange}
                            options={props.ChannelType === ChannelType.FACEBOOK ? Object.values(Fb24HourWindowTags) : [Fb24HourWindowTags.HUMAN_AGENT]}
                            getOptionLabel={(tag) => tag}
                            disableClearable
                            classes={{
                                option: "custom-option",
                                input: `color-channel-tag-input h6-regular`
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Select"
                                    required
                                    variant='outlined'
                                    size='small'
                                    className="color-primary"
                                    onKeyDown={(e)=>{e.preventDefault()}}
                                    InputLabelProps={{
                                        shrink: true,
                                    }} />}
                        />
                        <Tooltip title='info' placement="right-end">
                            <span className={"mt-2"}>
                                <FbTagsInfoIcon className={"c-pointer"} onClick={handleMessageTagsInfo} />
                            </span>
                        </Tooltip>
                    </div>
                }
            </div>
            {
                messageTagsInfoOpen &&
                <Dialog
                    onBackdropClick={handleMessageTagsInfo}
                    maxWidth='sm'
                    open={messageTagsInfoOpen}
                    onClose={() => { }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    BackdropProps={{ style: { backgroundColor: "transparent" } }} classes={{ paper: "w-70 br-2  dialogue-shadow" }}
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className="h2-regular color-text-field-font d-flex">
                            Message Tags <FbTagsInfoIcon className="ml-2" />
                            <Tooltip title='Close' placement='bottom'>
                                <span className={"ml-auto"}>
                                    <CancelIcon className={"c-pointer"} onClick={handleMessageTagsInfo} />
                                </span>
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <DialogContent className={` w-p-91 pb-0`}>
                        <div className='b-around-text-field-border-4 br-0_2 p-3 h5-regular d-flex flex-direction justify-center align-center' id="alert-dialog-description">
                            <div className="bb-primary-divider-4">
                                <div className='d-flex flex-direction justify-between '>
                                    <div className={`h3-bold color-header-title-font`}>Account Update</div>
                                    <div>A notification for a change in status for an application, such as for a credit card or job application</div>
                                </div>
                                <div className="d-flex w-p-100 my-1 bg-color-channel-message-tags-info py-1">
                                    <div>
                                        <BlueTickIcon className="mx-1" />
                                    </div>
                                    <div>A notification for suspicious activity, such as fraud alerts</div>
                                </div>
                            </div>
                            <div className="bb-primary-divider-4">
                                <div className='w-p-100'>
                                    <div className={`h3-bold color-header-title-font`}>Confirmed Event Update</div>
                                </div>
                                <div className="d-flex w-p-100 mt-1 bg-color-channel-message-tags-info py-1">
                                    <div>
                                        <BlueTickIcon className="mx-1" />
                                    </div>
                                    <div>A reminder for an upcoming class, appointment, or event that a user has scheduled</div>
                                </div>
                                <div className="d-flex w-p-100 mt-1 bg-color-channel-message-tags-info py-1">
                                    <div>
                                        <BlueTickIcon className="mx-1" />
                                    </div>
                                    <div>A confirmation for a user's reservation or attendance to an accepted event or appointment</div>
                                </div>
                                <div className="d-flex w-p-100 my-1 bg-color-channel-message-tags-info py-1">
                                    <div>
                                        <BlueTickIcon className="mx-1" />
                                    </div>
                                    <div>A notification for a user's transportation or scheduled trip, such as arrival, cancellation, baggage delay, or other travel status changes</div>
                                </div>
                            </div>
                            <div className="w-p-100">
                                <div className='w-p-100'>
                                    <div className={`h3-bold color-header-title-font`}>Customer Feedback</div>
                                </div>
                                <div className="d-flex w-p-100 mt-1 bg-color-channel-message-tags-info py-1">
                                    <div>
                                        <BlueTickIcon className="mx-1" />
                                    </div>
                                    <div>A survey for purchase support feedback</div>
                                </div>
                                <div className="d-flex w-p-100 mt-1 bg-color-channel-message-tags-info py-1">
                                    <div>
                                        <BlueTickIcon className="mx-1" />
                                    </div>
                                    <div>A survey for event feedback</div>
                                </div>
                                <div className="d-flex w-p-100 mt-1 bg-color-channel-message-tags-info py-1">
                                    <div>
                                        <BlueTickIcon className="mx-1" />
                                    </div>
                                    <div>Product reviews</div>
                                </div>
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            }
        </div >
    )
}

export default ChannelErrorMessageComponent
